import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import type { IGetUserClient } from '../data/data-sources/i-get-user-client'
import type { GetUserParams } from '../domain/models/get-user'
import type { ApiResponse, AxiosDataResponse } from '../../../config/api-types'
import { USER_ENDPOINTS } from '../../../config/endpoints'

export class GetUserService implements IGetUserClient {
  constructor(private readonly axios: AxiosInstance) {}

  async get(params: GetUserParams): Promise<ApiResponse> {
    try {
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.get(
        USER_ENDPOINTS.getUser,
        { params },
      )

      return {
        success: result.data.success,
        data: result.data.data,
        message: result.data.message,
        status: result.status,
      }
    } catch (error: any) {
      const axiosError = error as AxiosError<AxiosDataResponse>
      return {
        success: false,
        message: axiosError.response?.data?.message,
        status: axiosError.response?.status!,
      }
    }
  }
}
